<template>
  <div
    class="job-parameters-bar"
    v-if="parameters && Object.keys(parameters).length > 0"
  >
    <div class="params-content">
      <span
        v-for="(value, key) in displayParameters"
        :key="key"
        class="param-tag"
      >
        <span class="param-key">{{ formatLabel(key) }}:</span>
        <span class="param-value">{{ formatValue(value) }}</span>
      </span>
    </div>
    <span
      v-if="status"
      class="status-badge"
      :class="'status-' + status.toLowerCase()"
    >
      {{ status }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'JobParameters',
  props: {
    parameters: {
      type: Object,
      default: () => ({})
    },
    status: {
      type: String,
      default: ''
    }
  },
  computed: {
    displayParameters() {
      if (!this.parameters) return {}
      const result = {}
      Object.keys(this.parameters).forEach(key => {
        const value = this.parameters[key]
        // Skip empty arrays and null/undefined
        if (Array.isArray(value) && value.length === 0) return
        if (value === null || value === undefined) return
        result[key] = value
      })
      return result
    }
  },
  methods: {
    formatLabel(key) {
      // camelCase → Title Case
      return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, s => s.toUpperCase())
        .trim()
    },
    formatValue(value) {
      if (Array.isArray(value)) {
        return value.join(', ')
      }
      if (typeof value === 'object' && value !== null) {
        return JSON.stringify(value)
      }
      return String(value)
    }
  }
}
</script>

<style scoped lang="scss">
.job-parameters-bar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 15px;
  padding: 8px 0;
  font-size: 13px;

  .params-content {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 12px;
    flex: 1;
    min-width: 0;
  }

  .param-tag {
    white-space: nowrap;
    color: #555;

    .param-key {
      font-weight: 600;
      color: #555;
      margin-right: 3px;
      margin-right: 8px;
    }

    .param-value {
      color: #303133;
    }
  }

  .status-badge {
    flex-shrink: 0;
    font-weight: 700;
    font-size: 11px;
    padding: 1px 8px;
    border-radius: 3px;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    &.status-completed {
      color: #28a745;
      background-color: #e6f7ee;
    }

    &.status-failed {
      color: #dc3545;
      background-color: #fde8ea;
    }

    &.status-processing {
      color: #e6a23c;
      background-color: #fdf6ec;
    }

    &.status-queued,
    &.status-pending {
      color: #17a2b8;
      background-color: #e8f7fa;
    }
  }
}
</style>
